import { Component, ReactNode } from "react";

import { ChooserContext } from "~/components/shared/Chooser/context";
import Option from "~/components/shared/Chooser/option";
import SelectOption from "~/components/shared/Chooser/select-option";

interface ChooserProps {
  children: ReactNode;
  className?: string;
  multiple?: boolean;
  selected?: any;
  onSelect: (value: any, data?: any) => void;
}

interface ChooserStatics {
  Option: typeof Option;
  SelectOption: typeof SelectOption;
}

class Chooser extends Component<ChooserProps> {
  static Option = Option;
  static SelectOption = SelectOption;

  render() {
    return (
      <ChooserContext.Provider value={this}>
        <section className={this.props.className}>{this.props.children}</section>
      </ChooserContext.Provider>
    );
  }

  isSelected(value: any) {
    if (this.props.multiple) {
      return this.props.selected.indexOf(value) >= 0;
    }

    return this.props.selected === value;
  }

  handleChoiceClick = (value: any, data?: any) => {
    this.props.onSelect(value, data);
  };
}

export default Chooser as typeof Chooser & ChooserStatics;
